<template>
  <div :class="checkWidth() + ' ' + 'container example-3d'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>

    <template v-else>
      <template v-if="CheckWidth >= 501">
        <CRow alignHorizontal="end" style="margin-right: 50px">
          <CCol
            col="2"
            style="text-align: center"
            @mouseover="hover = true"
            @mouseleave="hover = false"
          >
            <template>
              <h4>Post-Test</h4>
              <img
                v-if="!openPostTest"
                :class="postTestClass()"
                src="https://mdl.mfu.ac.th/chinese/Image/ITEM/paperroll/close_box.png?fbclid=IwAR3Dm6cvqoZgKkOgWAQgTW_vWDCFJiZMdsYkxJdaoiIIc-zPwPqPj4DiGdQ"
                style="width: 150px; height: 150px"
              />
              <img
                v-else-if="openPostTest && postTest"
                :class="postTestClass()"
                src="https://mdl.mfu.ac.th/chinese/Image/ITEM/paperroll/open_box.png?fbclid=IwAR3RqdS3kXALPpUCckSw1ixhI292Ni8fGkOEODUcB1QCpc28bExvTyJXVJI"
                style="width: 150px; height: 150px"
              />
              <img
                v-else-if="openPostTest && !postTest && hover"
                :class="postTestClass()"
                src="https://mdl.mfu.ac.th/chinese/Image/ITEM/paperroll/open_box.png?fbclid=IwAR3RqdS3kXALPpUCckSw1ixhI292Ni8fGkOEODUcB1QCpc28bExvTyJXVJI"
                style="width: 150px; height: 150px; cursor: pointer"
                @click="funcPostTest()"
              />
              <img
                v-else-if="openPostTest && !postTest && !hover"
                :class="postTestClass()"
                src="https://mdl.mfu.ac.th/chinese/Image/ITEM/paperroll/close_box.png?fbclid=IwAR3Dm6cvqoZgKkOgWAQgTW_vWDCFJiZMdsYkxJdaoiIIc-zPwPqPj4DiGdQ"
                style="width: 150px; height: 150px; cursor: pointer"
                @click="funcPostTest()"
              />
            </template>
          </CCol>
        </CRow>
      </template>

      <template v-else-if="CheckWidth <= 500">
        <CRow alignHorizontal="center" style="margin-bottom: 70px">
          <CCol col="6" style="text-align: center">
            <button
              v-if="openPostTest && !postTest"
              type="button"
              class="btn btn-success btn-lg"
              @click="funcPostTest()"
            >
              <font-awesome-icon
                icon="check-circle"
                style="margin-right: 5px"
              />
              POST TEST
            </button>
            <button v-else type="button" class="btn btn-danger btn-lg" disabled>
              POST TEST LOCKED
            </button>
          </CCol>
        </CRow>
      </template>

      <template v-if="CheckWidth >= 501">
        <CModal
          title="Calm Down!"
          centered
          color="warning"
          :show.sync="warningModal"
          :closeOnBackdrop="false"
          ref="mySwiper"
        >
          <h5>
            Students will be able to learn the next chapter when the system
            shows more than 80% of their previous chapter.
          </h5>
          <br />
        </CModal>
        <CModal
          title="Calm Down!"
          centered
          color="warning"
          :show.sync="adminLockTestModal"
          :closeOnBackdrop="false"
          ref="mySwiper"
        >
          <h5>The Post-Test has been locked by your instructor.</h5>
          <br />
        </CModal>
        <CModal
          :title="this.lang === 'TH' ? 'ข้อควรทราบ' : 'Important Notice'"
          centered
          color="warning"
          :show.sync="warningTestModal"
          :closeOnBackdrop="false"
        >
          <h5>
            {{
              this.lang === 'TH'
                ? 'แบบทดสอบนี้สามารถทำได้เพียงครั้งเดียว กรุณาทำให้เสร็จจนจบหากออกจากระบบหรือหลุดระหว่างทำ คะแนนจะไม่ถูกบันทึก'
                : ' This test can be taken only once. Please complete it in one session. If you leave or are logged out before finishing, your score will not be saved.'
            }}
          </h5>
          <!-- <br /> -->
          <template slot="footer">
            <div class="d-flex justify-content-end gap-2">
              <CButton color="secondary" @click="warningTestModal = false">
                Cancel
              </CButton>
              <CButton color="success" class="ml-2" @click="proceedToPostTest">
                OK
              </CButton>
            </div>
          </template>
        </CModal>

        <swiper
          v-if="content.content?.item"
          class="swiper"
          ref="mySwiper"
          :options="swiperOption"
          @click="handleClickForSlide"
        >
          <template v-for="(item, index) in content.content.item">
            <swiper-slide :key="index">
              <div class="swip" :id="item.id">
                <img
                  :src="baseUrl + item.icon.enable.data"
                  :class="checkID(index)"
                />
                <div class="name" style="text-align: center">
                  <h1
                    :class="checkLangClass()"
                    v-html="checkLanguage(item.title)"
                  ></h1>
                </div>
                <!-- <div>{{ index }}</div> -->

                <!-- FOR Progress Bar -->
                <div class="ContentProgressBar">
                  <CProgress
                    showPercentage
                    class="ProgressBar"
                    :value="Math.floor(v3Progress[index]?.progress || 0)"
                    show-value
                    height="30px"
                    color="success"
                  />
                </div>
              </div>
            </swiper-slide>
          </template>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </template>

      <template v-else-if="CheckWidth <= 500">
        <CModal
          title="Calm Down!"
          centered
          color="warning"
          :show.sync="warningModal"
          :closeOnBackdrop="false"
          ref="mySwiper"
        >
          <h5>
            Students will be able to learn the next chapter when the system
            shows more than 80% of their previous chapter.
          </h5>
          <br />
        </CModal>
        <CModal
          title="Calm Down!"
          centered
          color="warning"
          :show.sync="adminLockTestModal"
          :closeOnBackdrop="false"
          ref="mySwiper"
        >
          <h5>The Post-Test has been locked by your instructor.</h5>
          <br />
        </CModal>
        <CModal
          :title="this.lang === 'TH' ? 'ข้อควรทราบ' : 'Important Notice'"
          centered
          color="warning"
          :show.sync="warningTestModal"
          :closeOnBackdrop="false"
        >
          <h5>
            {{
              this.lang === 'TH'
                ? 'แบบทดสอบนี้สามารถทำได้เพียงครั้งเดียว กรุณาทำให้เสร็จจนจบหากออกจากระบบหรือหลุดระหว่างทำ คะแนนจะไม่ถูกบันทึก'
                : ' This test can be taken only once. Please complete it in one session. If you leave or are logged out before finishing, your score will not be saved.'
            }}
          </h5>

          <!-- <br /> -->
          <template slot="footer">
            <div class="d-flex justify-content-end gap-2">
              <CButton color="secondary" @click="warningTestModal = false">
                Cancel
              </CButton>
              <CButton color="danger" class="ml-2" @click="proceedToPostTest">
                OK
              </CButton>
            </div>
          </template>
        </CModal>
        <swiper
          v-if="content?.content?.item"
          class="swiper"
          ref="mySwiper"
          :options="swiperOptionPhone"
          @click="handleClickForSlide"
        >
          <template v-for="(item, index) in content.content.item">
            <swiper-slide :key="index">
              <div class="swip" :id="item.id">
                <img
                  :src="baseUrl + item.icon.enable.data"
                  :class="checkID(index)"
                />
                <center></center>
                <div class="name">
                  <h1
                    :class="checkLangClass()"
                    v-html="checkLanguage(item.title)"
                  ></h1>
                </div>
                <!-- <div>{{ item }}</div> -->

                <!-- FOR Progress Bar -->
                <div class="ContentProgressBar">
                  <CProgress
                    showPercentage
                    class="ProgressBar"
                    :value="Math.floor(v3Progress[index]?.progress)"
                    animated
                    show-value
                    height="30px"
                    color="success"
                  />
                </div>
              </div>
            </swiper-slide>
          </template>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </template>
    </template>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import {mapGetters} from 'vuex';
import '../../../assets/scss/_chineseStyle.scss';
import '../../../assets/css/sun.css';
import LoadingMDL from '../../../components/loading/LoadingMDL.vue';
//1 show data template
//2.show progress
//3.cannot learn next card if previous lesson less than 80%
//4.dont forget change lang function
//5.if all progress not 100 percent cannot do post test
//5. after finish chapter need to redirect to display page everytime
//6.ทำตัว บันทึก progress

export default {
  name: 'LessonSelect',
  title: '3D Coverflow effect Loop mode with multiple slides per group',
  components: {
    Swiper,
    SwiperSlide,
    LoadingMDL,
  },
  props: {
    id: String,
  },
  data() {
    return {
      hover: false,
      preTest: false,
      lang: '',
      content: {},
      baseUrl: '',
      counter: 86,
      swiperOption: {
        effect: 'coverflow',
        slidesPerView: 2.5,
        initialSlide: 0,
        grabCursor: false,
        centeredSlides: true,
        loop: true,
        loopFillGroupWithBlank: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 5,
          depth: 25,
          modifier: 5,
          slideShadows: false,
        },
        on: {},
      },
      swiperOptionPreTest: {
        effect: 'coverflow',
        slidesPerView: 2.5,
        grabCursor: false,
        centeredSlides: true,
        loop: false,
        loopFillGroupWithBlank: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 5,
          depth: 25,
          modifier: 5,
          slideShadows: false,
        },
      },
      swiperOptionPhone: {
        effect: 'coverflow',
        slidesPerView: 1,
        initialSlide: 0,
        grabCursor: false,
        centeredSlides: true,
        loop: true,
        loopFillGroupWithBlank: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 5,
          depth: 25,
          modifier: 5,
          slideShadows: false,
        },
      },
      CheckWidth: window.innerWidth,
      progress: {},
      progress2: {},
      warningModal: false,
      openPostTest: false,
      postTest: false,
      courseSection: '',
      startTime: '',
      courseCode: '',
      allChapter: [],
      postTestComplete: false,
      loading: true,
      openPostTestByAdmin: false,
      adminLockTestModal: false,
      v3Progress: [],
      v3MockData: [],
      warningTestModal: false,
      swiper: {},
    };
  },
  created() {},
  mounted() {
    if (
      this.$store.state.v4.v4CurrentMainCodeItem &&
      this.$store.state.v4.v4DataStack.length !== 0
    ) {
      // console.log('pigeon run!');

      this.$store.dispatch('v4/forceSavePayload', {
        mainCodeItem: this.$store.state.v4.v4CurrentMainCodeItem,
        mainType: this.$store.state.v4.v4MainType,
        mainContent: this.$store.state.v4.v4MainContent,
        dataStack: this.$store.state.v4.v4DataStack,
        pages: this.$store.state.v4.v4Pages,
        courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
        section: this.$store.state.v3.v3EnrollData.data.section,
      });
    } else {
      this.onLoad();
    }
  },
  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',
      getLessonActive: 'necessary/getLessonActive',
      getCourseProgress: 'v3/getCourseProgress',
      getTemplatev3: 'v3/getTemplates',
      v3LessonLockStatus: 'v3-data/v3LessonLockStatus',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
  },

  watch: {
    getTemplatev3: {
      handler(val) {
        if (!val) return;

        this.v3Data = val;
        const template = val.templates[0];
        this.content = template;

        const payload = {
          codeItem: template.codeTemplate,
          courseId: this.$store.state.necessary.learningCourse,
        };
        this.$store.dispatch('v3/fetchCourseProgress', payload); // เรียก progress มาแสดงจาก backend --> ไปที่ Watch เพื่อเช็คข้อมูล
        // this.loading = false;
      },
    },

    storeLanguage: function (val) {
      this.lang = val;
    }, //
    getLessonActive: function (val) {
      // console.log(val, 'get Lesson active');

      this.swiperOption.initialSlide = val;
      this.swiperOptionPhone.initialSlide = val;
    }, //
    getCourseProgress: function (data) {
      // console.log('getCourseProgress', data);
      //check PostTest
      if (!data) {
        // console.log('GET COURSE PROGRESS FAIL HAS NO DATA:', data);
        return;
      }

      if (!data.progress) {
        // console.log(
        //   'GET COURSE PROGRESS FAIL HAS DATA BUT NO PROGRESS:',
        //   data.progress
        // );
        return;
      }

      this.v3MockData = data.progress;
      this.v3DefineProgressAndLockedTest(this.content);
      this.checkPostTest(data.progress);

      this.stopLoading();
    },
    v3LessonLockStatus(val) {
      if (this.openPostTest && !val.isLock) {
        this.warningTestModal = true;
      } else {
        this.adminLockTestModal = true;
      }
    },
    saveContentStatusv4: function () {
      // console.log('save content respond');
      //get Progress after watch trigger
      this.onLoad();
    },
  },
  beforeDestroy() {
    this.$store.commit('v3/clearCourseProgress'); //เคลีย progress เก่าออก // ปล.ทำให้ watch เรียก 2 รอบต้องระวัง
  },
  methods: {
    onLoad() {
      this.loading = true;

      // console.log('onLoad run');

      // เคลียค่าใน vuex storage ก่อน
      // this.$store.commit('v3/clearMainCodeItem'); // เคลีย content ที่แล้วออก
      // this.$store.commit('v3/clearCourseProgress'); //เคลีย progress เก่าออก // ปล.ทำให้ watch เรียก 2 รอบต้องระวัง
      this.$store.commit('v3/v3PretestOff'); // เคลียสถานะ pretest ออก

      //Lesson Active Check
      let lessonActive = this.$store.getters['necessary/getLessonActive'];
      this.swiperOption.initialSlide = lessonActive;
      this.swiperOptionPhone.initialSlide = lessonActive;

      //lang
      this.lang = this.$store.state.language.language;
      //sound
      this.baseUrl = process.env.VUE_APP_URL_SOUND;
      //start Time
      this.startTime = this.$helpers.getDateFormat();

      // //get courseCode from getLearningCourse
      // this.courseCode = this.$store.getters['necessary/getLerningCourse']._id;

      //เรียก template มาแสดง
      // this.v3MockData = this.$store.getters['v3/getCourseProgress'].progress;
      const contentId = `HP01-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);

      this.$store.dispatch('v3/v3LessonLock', {
        courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
        section: this.$store.state.v3.v3EnrollData.data.section,
      });
    },
    stopLoading() {
      this.loading = false;
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
    },
    checkID(id) {
      ///if empty array
      const lock = this.v3Progress[id]?.lock ?? true;
      const prevProgress =
        this.v3Progress[id === 0 ? id : id - 1]?.progress ?? 0;

      //if not lock
      if (!lock) {
        return 'img-island';
      }
      //if lock and prev progress < 80
      if (lock && prevProgress < 80) {
        return 'img-islandGrey';
      }
      //if lock but prev progress is enough
      return 'img-island';
    },
    postTestClass() {
      if (!this.openPostTest) {
        return 'box-gray';
      }
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            var spiltVal = val[i].value;
            let spl = spiltVal.split('-');
            return spl[0] + '<br/>' + spl[1];
          }
        }
      } else {
        console.log('change language is error!!');
      }
    },
    funcRoute(tempId, index, item) {
      // ตัวกดปุ่มเข้าสู่บทต่างๆ
      // console.log('funcRoute', tempId, index, item);

      // chinese1, after click it will go fetch data from backend by using wrap data
      // by making payload like this {}
      //
      //

      //
      const v3CodeItem = tempId;

      //checking if prev progress that already 80 ? if less cannot click or proceed
      const lock = this.v3Progress[index]?.lock ?? true;

      const prevProgress =
        this.v3Progress[index === 0 ? index : index - 1]?.progress ?? 0;

      if (lock && prevProgress < 80) {
        this.warningModal = true;
      } else {
        this.$store.commit('v3/setFetchDataBy', 'code'); // call mutation from vuex storage
        this.$store.commit('v3/clearMainCodeItem'); // clear mainCodeItem

        //stamp main lesson code and commit isLesson true
        this.$store.commit('v3/stampMainLesson', tempId);
        // this.$store.commit('v3/v3IsLessonOn');

        //stamp data by tempid
        const lessonLock = this.$store.state.v3.lessonLock;
        //if have lesson lock
        if (lessonLock) {
          const filterLessonLock = lessonLock.filter(
            (item) => item.codeItem == tempId
          );
          //assign to lockData pass to another page
          this.$store.commit('v3/setLockData', filterLessonLock[0]);
        }

        const pathFormat = v3CodeItem.split('-');

        this.$router.push(`/v4/${pathFormat[0]}/${pathFormat[1]}`);
      }

      // // ของเก่า ไม่ต้องลบ
      // this.$store.commit('necessary/setLessonActive', index);
      // var lock = this.allChapter[index].lock;
      // var progress = this.allChapter[index].progress;
      // if (lock) {
      //   this.warningModal = true;
      // } else {
      //   let str = tempId.split('-');
      //   let body = '/' + str[0] + '/' + str[1];
      //   this.$router.push(body);
      // }
    },
    funcPostTest() {
      const payload = {
        courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
        section: this.$store.state.v3.v3EnrollData.data.section,
        codeItem: 'HP02-11',
      };
      this.$store.dispatch('v3-data/v3LessonLockStatus', payload);
    },

    v3DefineProgressAndLockedTest(val) {
      let pretest = null;
      const defaultChapter = [];
      const allChapters = [];

      // is use for define that's how much chapter do we have ?
      for (let i = 0; i < val.content?.item?.length; i++) {
        const chapter = val.content.item[i];
        defaultChapter.push({
          code: chapter.navigate.action,
          progress: 0,
          lock: false,
        }); // set default first
      } // loop

      // then use this mix with progress
      for (let i = 0; i < defaultChapter.length; i++) {
        const chapter = defaultChapter[i];
        let nextLock = false;

        let schema = {
          code: chapter.code,
          progress: 0,
          lock: false,
          type: 'chapter',
        };

        //
        for (let j = 0; j < this.v3MockData.length; j++) {
          const progress = this.v3MockData[j];
          if (progress.type == 'pretest') {
            // เก็บ pretest ไว้เช็คค่าสำหรับ re-direct ไปที่แบบ pretest
            if (pretest == null) {
              pretest = progress;
            }
          }

          if (progress.codeItem) {
            if (chapter.code == progress.codeItem) {
              // console.log(
              //   'this is:',
              //   chapter.code,
              //   'and progress:',
              //   progress.progress
              // );
              schema.progress = progress.progress;
            }
          }
        } // loop 2

        if (schema.progress < 80 && i >= 1) {
          // i > 1 is chapter 2 until others chapter end
          nextLock = true;
        }
        schema.lock = nextLock;

        allChapters.push(schema); // set default first
      } // loop

      this.v3Progress = allChapters;

      // console.log(defaultChapter, 'default');
      // console.log(allChapters, 'default');
      // console.log(this.v3Progress);

      if (pretest) {
        // console.log(
        //   'pretest.progress pretest.progress pretest.progress',
        //   pretest.progress
        // );

        if (pretest.progress < 50) {
          // ทำตัว re-direct ไปที่หน้า CTT01-11

          const pretestStart = 'CTT01-11';
          const pathFormat = pretestStart.split('-');

          this.$store.commit('v3/v3PretestOn');
          this.$store.commit('v3/stampMainCodeItem', pretestStart);
          this.$store.commit('v3/setFetchDataBy', 'code'); // call mutation from vuex storage
          // console.log('Re-direct to Pretest By', pretestStart);

          this.$router.push(`/v4/${pathFormat[0]}/${pathFormat[1]}`);
        }
      }
      this.loading = false;
    },

    checkPostTest(progress) {
      //store
      // const lessonLock = this.$store.state.v3.lessonLock;
      //filter data exclude type posttest
      const filterLastChapter = progress.filter(
        (item) => item.codeItem === 'HP02-10'
      );

      const lastChapter = filterLastChapter[0];

      //use lastchapter progress  and lock
      if (lastChapter.progress >= 80) {
        //if lock off pass
        this.openPostTest = true;
      } else {
        //no pass
        this.openPostTest = false;
      }

      //condition
      //check to assign status isPostTest
      //if allChapter progress >= 80 ? true : false
      //if isPostTest if have payload codeItem this.onLoad
      // else dispatch saveScoreAndProgress
      // for (let index = 0; index < array.length; index++) {
      //   const element = array[index];
    },
    proceedToPostTest() {
      let body = '/v4/LKT01/78';
      this.$router.push(body);
    },
    handleClickForSlide() {
      const swiper = this.$refs.mySwiper.$swiper;
      if (!swiper) return;
      const realIndex = swiper.realIndex;

      const indexItem = this.content.content.item[realIndex];
      if (indexItem) {
        this.funcRoute(indexItem.navigate.action, realIndex);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap');

.vertical-center {
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box-gray {
  filter: grayscale(100%) blur(2px) !important;
}

.container-chinese-card {
  padding-top: 7% !important;
  padding-bottom: 5% !important;
}

.container-chinese-card-mobile {
  padding-top: 35% !important;
  padding-bottom: 5% !important;
}

.Greyfillter {
  filter: grayscale(100%);
}

.ContentProgressBar {
  display: flex;
  justify-content: center;

  .ProgressBar {
    background-color: #cccccc !important;
    margin-top: 5%;
    width: 70% !important;
    height: 20px !important;
    border-radius: 20px !important;
  }
}

.progress-bar-striped {
  background-image: none !important;
}

.example-3d {
  align-items: center;
  width: 100% !important;
  padding-top: 11%;
  padding-bottom: 4%;
}

.swiper {
  min-height: 600px;
  height: 100%;
  width: auto;

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
    background-color: transparent;
    background-position: center;
    color: white;
  }

  .swip {
    height: inherit;
    filter: blur(5px);
  }

  .img-island {
    width: 80% !important;
    margin-bottom: 5%;
    cursor: pointer;
  }

  .img-islandGrey {
    width: 80% !important;
    margin-bottom: 5%;
    filter: grayscale(100%);
  }

  .swiper-slide-active {
    .swip {
      height: inherit;
      filter: blur(0px) !important;
    }

    .img-island {
      width: 80% !important;
      filter: grayscale(0%);
    }
  }

  .btn {
    width: 150px;
    height: 50px;
    border-radius: 60px;
    font-size: 30px;
  }

  .name h1 {
    font-size: 20px;
    color: black !important;
    margin-top: 1rem;
    font-size: 40px;
    font-family: 'Roboto', sans-serif;
    font-weight: 300;
  }
}
</style>
